import React, { useState, useEffect, useRef } from "react";
import { TabsContainer, TabsWrapper, TabItem } from "./SecondaryTabs.styles";
import { SecondaryTabsProps } from "./SecondaryTabs.types";
import { Body5MediumTypography } from "../../primitives/Typography/typographyVariants";
import { colorGuide, colorPalette } from "../../theme/colors";
import { Skeleton } from "@mui/material";

export const SecondaryTabs: React.FC<SecondaryTabsProps> = ({
  tabs,
  selectedTabId,
  onTabChange,
  isLoading = false,
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(
    tabs.findIndex((tab) => tab.id === selectedTabId)
  );
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);

  // Handle tab change
  const changeTab = (index: number) => {
    if (index >= 0 && index < tabs.length) {
      setSelectedTabIndex(index);
      onTabChange(tabs[index].id);
    }
  };

  useEffect(() => {
    const newIndex = tabs.findIndex((tab) => tab.id === selectedTabId);
    if (newIndex !== -1 && newIndex !== selectedTabIndex) {
      setSelectedTabIndex(newIndex);
    }
  }, [selectedTabId, tabs]);

  return (
    <TabsContainer>
      {tabs.map((tab, index) => (
        <TabItem
          key={tab.id}
          ref={(el) => (tabRefs.current[index] = el)}
          isActive={selectedTabIndex === index}
          onClick={() => changeTab(index)}
          disabled={!tab?.clickable}
          data-cy={tab?.dataCy}
          className={selectedTabIndex === index ? "active" : ""}
        >
          {isLoading ? (
            <Skeleton width={80} />
          ) : (
            <Body5MediumTypography
              textAlign="center"
              color={
                selectedTabIndex === index
                  ? colorGuide.lightComponents.secondaryTab.tabItem.active.color
                  : colorGuide.lightComponents.secondaryTab.tabItem.color
              }
            >
              {tab?.name}
            </Body5MediumTypography>
          )}
        </TabItem>
      ))}
    </TabsContainer>
  );
};
